"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteFileAPICallAsync = exports.useFormDataAPICallAsync = exports.HEADER_KEY_PREFIX = void 0;
var react_1 = __importDefault(require("react"));
var functions_1 = require("../functions");
exports.HEADER_KEY_PREFIX = 'x-amz-meta-';
function useFormDataAPICallAsync(_a) {
    var _this = this;
    var centralUserProfile = _a.centralUserProfile, bearer = _a.bearer, api = _a.api, customFields = _a.customFields;
    var _b = __read(react_1.default.useState({ data: [], loading: false, error: '' }), 2), result = _b[0], setResult = _b[1];
    var call = react_1.default.useCallback(function (param) { return __awaiter(_this, void 0, void 0, function () {
        var d, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setResult(__assign(__assign({}, result), { loading: true }));
                    if (!api.endpoint) {
                        setResult({ data: [], loading: false, error: '' });
                        return [2 /*return*/, { data: [], loading: false, error: '' }];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, functions_1.createFormDataApiCall(__assign({ centralUserProfile: centralUserProfile,
                            bearer: bearer, url: api.endpoint, data: param }, customFields))];
                case 2:
                    d = _a.sent();
                    setResult({ data: d.body, loading: false, error: '' });
                    return [2 /*return*/, { data: d.body, loading: false, error: '' }];
                case 3:
                    e_1 = _a.sent();
                    setResult({ data: [], loading: false, error: e_1.message });
                    return [2 /*return*/, { data: [], loading: false, error: e_1.message }];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [api, customFields]);
    return { result: result, call: call };
}
exports.useFormDataAPICallAsync = useFormDataAPICallAsync;
function useDeleteFileAPICallAsync(_a) {
    var _this = this;
    var bearer = _a.bearer, api = _a.api, customFields = _a.customFields;
    var _b = __read(react_1.default.useState({ data: [], loading: false, error: '' }), 2), result = _b[0], setResult = _b[1];
    var call = react_1.default.useCallback(function (param) { return __awaiter(_this, void 0, void 0, function () {
        var d, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setResult(__assign(__assign({}, result), { loading: true }));
                    if (!api.endpoint) {
                        setResult({ data: [], loading: false, error: '' });
                        return [2 /*return*/, { data: [], loading: false, error: '' }];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, functions_1.createDeleteFileApiCall(__assign({ bearer: bearer, url: api.endpoint + "/" + param.fileName }, customFields))];
                case 2:
                    d = _a.sent();
                    setResult({ data: d.body, loading: false, error: '' });
                    return [2 /*return*/, { data: d.body, loading: false, error: '' }];
                case 3:
                    e_2 = _a.sent();
                    setResult({ data: [], loading: false, error: e_2.message });
                    return [2 /*return*/, { data: [], loading: false, error: e_2.message }];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [api, customFields]);
    return { result: result, call: call };
}
exports.useDeleteFileAPICallAsync = useDeleteFileAPICallAsync;
//# sourceMappingURL=useFormDataAPICallAsync.js.map